import { StandardEvents } from '@shopify/events';

// Horizon changes filter URLs without restoring the collection on popstate.
// A native reload restores the complete landing, results and pagination together.
let currentSearch = window.location.search;

document.addEventListener(StandardEvents.collectionUpdate, () => {
  currentSearch = window.location.search;
});

window.addEventListener('popstate', () => {
  if (window.location.search !== currentSearch) window.location.reload();
});
